<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails de la cagnotte</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="text-center mb-3">
          <b-image class="mb-1 picture" :src="picture" thumbnail/>
          <br/>
          <d-link :href="link" target="_blank">
            Page de la cagnotte <i class="fa fa-external-link-alt"></i>
          </d-link>
        </div>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input container-class="mb-3" label="Auteur" :value="author" disabled/>
            <c-input container-class="mb-3" label="Catégorie" :value="category" disabled/>
            <c-input container-class="mb-3" label="Titre" :value="title" disabled/>
            <c-input type="textarea" container-class="mb-3" label="Résumé" :value="summary" disabled/>
            <c-input type="date" container-class="mb-3" label="Date de création" :value="created_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Date butoire" :value="deadline" disabled/>
          </d-col>
          <d-col class="ml-2">
            <c-input type="price" currency="XAF" container-class="mb-3" label="Montant collecté"
                     :value="amount_collected" disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Solde" :value="balance"
                     disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Objectif" :value="target_amount"
                     disabled/>
            <c-input type="date" container-class="mb-3" label="Clôturée le" :value="closed_at" disabled/>
            <d-form-checkbox class="mb-3" v-model="closed">
              Clôturée
            </d-form-checkbox>
            <d-form-checkbox class="mb-3" v-model="disabled">
              Bloquée
            </d-form-checkbox>
            <c-input v-if="disabled" type="textarea" container-class="mb-3" label="Motif du blocage"
                     v-model="disabling_reason"/>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Rechercher par titre ou auteur..." v-model="search"/>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                            @click="onSearchSubmit">
            <template slot="icon">
              <i class="fa fa-search"></i>
            </template>
            Rechercher
          </c-button-spinner>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucune cagnotte trouvée.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, asset, formatAmount, Toast, truncate} from "@/helpers"

export default {
  title: "Gestion des cagnottes",
  data() {
    return {
      search: '',
      fetchingSearch: false,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'picture', label: 'Photo'},
        {key: 'title_pretty', label: 'Titre', sortable: true},
        {key: 'author', label: 'Auteur', sortable: true},
        {key: 'balance_pretty', label: 'Solde', sortable: true},
        {key: 'progress', label: 'Collecté / Objectif', sortable: true},
        {key: 'created_at', label: 'Créé le', sortable: true},
        {key: 'deadline_pretty', label: 'Date butoire', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {
          type: 'white',
          icon: 'fas fa-exchange-alt',
          title: "Transactions de la cagnotte",
          handler: this.onRedirectToTransaction
        },
        {type: 'white', icon: 'fa fa-ellipsis-h', title: "Détails de la cagnotte", handler: this.onItemSelect},
      ],

      modalVisible: false,

      selectedItem: null,

      closed: false,
      enabled: false,
      disabling_reason: '',

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return item.title.toLowerCase().includes(search)
          || item.author.toLowerCase().includes(search)
      })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    picture() {
      return this.itemSelected ? asset(this.selectedItem.image_path) : ''
    },
    link() {
      return this.itemSelected ? asset(this.selectedItem.link) : ''
    },
    author() {
      return this.itemSelected
        ? this.selectedItem.user.first_name + ' ' + this.selectedItem.user.last_name + (this.selectedItem.user.verified ? " ✔" : "")
        : ''
    },
    category() {
      return this.itemSelected ? this.selectedItem.raising_category.name : ''
    },
    title() {
      return this.itemSelected ? this.selectedItem.title : ''
    },
    summary() {
      return this.itemSelected ? this.selectedItem.summary : ''
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ''
    },
    deadline() {
      return this.itemSelected ? this.selectedItem.deadline : ''
    },
    amount_collected() {
      return this.itemSelected ? this.selectedItem.amount_collected : ''
    },
    balance() {
      return this.itemSelected ? this.selectedItem.balance : ''
    },
    target_amount() {
      return this.itemSelected ? this.selectedItem.target_amount : ''
    },
    closed_at() {
      return this.itemSelected ? this.selectedItem.closed_at : ''
    },
    disabled: {
      get() {
        return !this.enabled
      },
      set(value) {
        this.enabled = !value
      }
    }
  },
  created() {
    this.fetchingData = true
    Api.get('/raising/list')
      .then(res => this.data = res.data.raisings.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        picture: asset(item.image_path),
        title_pretty: truncate(item.title, 30) + (item.private ? ' 🔒' : ''),
        author: truncate(item.user.first_name + ' ' + item.user.last_name, 20) + (item.user.verified ? " ✔" : ""),
        balance_pretty: formatAmount(item.balance),
        progress: formatAmount(item.amount_collected) + ' / ' + formatAmount(item.target_amount),
        deadline_pretty: item.deadline.replace(' ', '\n'),
        status: item.closed ? "Clôturée" : !item.enabled ? "Bloquée" : !item.active ? "Inactive" : "Active",
        statusVariant: item.closed ? "secondary" : !item.enabled ? "danger" : !item.active ? "warning" : "success",
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.closed = item.closed
      this.enabled = item.enabled
      this.disabling_reason = item.disabling_reason
      this.modalVisible = true
    },
    clearFields() {
      this.closed = false
      this.enabled = true
      this.disabling_reason = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return true
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData('/raising/update', {
        raising_id: this.selectedItem.id,
        closed: this.closed,
        enabled: this.enabled,
        disabling_reason: this.disabling_reason,
      })
        .then(res => {
          const raising = this.mapItem(res.data.raising)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, raising)

          this.onModalClose()

          Toast.success(`La cagnotte "${raising.title}" a été mise à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/raising/find', {search: this.search})
        .then(res => this.data = res.data.raisings.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
    //redirect a rasing to its transactions
    onRedirectToTransaction(item) {
      this.$router.push({name: 'transactions', query: {entity: 'RAISING', id: item.id}});
    },
  }
}
</script>

<style scoped>
.picture {
  max-height: 200px;
}
</style>
